import { ICompPrice } from "features/Comp/interfaces";
import { apiClient } from "lib/apiClient";

export const addCompPrice = async (price: ICompPrice): Promise<ICompPrice> => {
  const response = await apiClient.post("/comps/price", price);

  return response.data;
};
